// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-footer[data-v-1d7b6c11]{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:center;align-items:center;padding:20px;font-size:14px;color:#6c757d}.expiration[data-v-1d7b6c11]{padding-top:20px;color:red;text-align:center;font-size:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
